<template>
  <BaseModal
    dataClass="info-modal"
    size="md"
    :title="columnInfos.info.label"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:main>
      <b-alert show variant="success">
        {{ message }}
      </b-alert>
    </template>
    <template v-slot:footer="{ cancel }">
      <!-- はいボタン -->
      <BaseButton
        variant="primary"
        :columnInfo="columnInfos.yes"
        @click="cancel"
      />
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: 'InfoModal',

  inheritAttrs: false,

  props: {
    /**
     * 項目定義情報.
     * @type {Object}
     */
    columnInfos: {
      type: Object,
      required: true,
    },

    /**
     * メッセージ.
     * @type {String}
     */
    message: {
      type: String,
      default: '',
    },
  },
}
</script>
